export default __webpack_public_path__ + "static/media/calendar-icon.615abd21.svg";